import { produce } from "immer";

export const setCalculationPaused = (state, paused) => {
  return produce(state, (draftState) => {
    draftState.calculationPaused = paused;
  });
};
